import { React, useContext } from 'react';
import PropTypes from 'prop-types';
import { CompanyContext, ConfigContext, ConfigLoadedContext } from '../../context/context';
import useTranslation from '../../hooks/useTranslation';
import { BsInstagram, BsLinkedin, BsFacebook } from "react-icons/bs";

import styles from './Footer.module.css';

import Button from '../Button/Button';
import Logo from '../Logo/Logo';
import Icon from '../Icon/Icon';

export default function Footer({ minimal }) {
  const config = useContext(ConfigContext);
  const configLoaded = useContext(ConfigLoadedContext);
  const company = useContext(CompanyContext);
  const t = useTranslation();

  let Footer;
  let itemsRows = [];
  let itemsSocials = [];

  // Funktion, um zu überprüfen, ob ein Link intern oder extern ist
  const isExternalLink = (url) => {
    return /^(http|https):\/\/|^www/.test(url);
  };

  if (configLoaded === true) {
    let currentRow = [];
    config.Fusszeile.forEach((item, index) => {
      if (item.header) {
        if (currentRow.length > 0) {
          itemsRows.push(currentRow);
          currentRow = [];
        }
        currentRow.push(
          <b key={"header_" + index}>
            <a href={item.link} className={styles.footerRow}>{item.name}</a>
          </b>
        );
      } else {
        currentRow.push(
          <a key={"item_" + index}
             className={styles.footerItem}
             href={item.link}
             target={isExternalLink(item.link) ? "_blank" : "_self"}
              rel="noreferrer"
          >
            {item.name}
          </a>
        );
      }
    });
    if (currentRow.length > 0) {
      itemsRows.push(currentRow);
    }

    let footerItemsSocials = config.Socials;
    if (footerItemsSocials !== undefined) {
      footerItemsSocials.forEach((socialItem, index) => {
        itemsSocials.push(
          <a key={"socials_" + index} href={socialItem.link} className={styles.socialIcons} target="_blank" rel="noreferrer">
            <Icon className={styles.socialIconElement} type="" icon={socialItem.type} color="white" size="20px" />
          </a>
        );
      });
    }

    let legalfooter = (
        <div className={styles.footerLegal}>
          <a className={styles.footerLegalItem} href={"/impressum"}>{t.c.footer.imprint}</a>
          <a className={styles.footerLegalItem} href={"/datenschutz"}>{t.c.footer.dataProtection}</a>
        </div>
    )
    if (!minimal) {
    Footer = (
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <div className={`${styles.footerCompany} col-sm-4 col-md-4 col-lg-2`}>
              <div className="col-sm-12 col-6">
                <Logo
                company={company}
                link="/"
                type="color-black"
                width="70%"
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className={`${styles.footerItems} col-md-2`}>
              <b className={styles.footerRow}>{config.Name}</b>
              <span className={styles.footerItem}>{config.AdresseZeile1}</span>
              <span className={styles.footerItem}>{config.AdresseZeile2}</span>
              { /* TODO: Move all Assets to A) Static Asset Folder in Bucket or B) Assets of Components-Gitlibrary */ }
              {company === "bauma" && (
                 <img
                   className={styles.siegel}
                   src="https://cdn.averecura.digital/brand-assets/bildwelt/bauma/siegel_konkordat.png"
                   alt="Konkordat Siegel"
                 />
               )}
              {company === "hinderzelg" && (
                 <img
                   className={styles.siegel}
                   src="https://cdn.averecura.digital/brand-assets/bildwelt/hinderzelg/bio-suisse.svg"
                   alt="Bio Suisse"
                 />
               )}
              {company === "zumipark" && (
                  <a
                      href="https://www.leadingnursinghomes.com/lnhfinder"
                      target="_blank"
                      rel="noreferrer"
                  >
                    <img
                        className={styles.siegel}
                        src="https://cdn.averecura.digital/brand-assets/bildwelt/zumipark/lnh-gold.jpg"
                        alt="Leading Nursing Homes Siegel"
                    />
                  </a>
              )}
            </div>
            {itemsRows.map((row, index) => (
              <div key={"row_" + index} className={`${styles.footerItems} col-md-2`}>
                {row}
                {index === itemsRows.length - 1 && itemsSocials.length > 0 ? (
                  <div className={styles.socialIconsWrapper}>
                    {itemsSocials}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
          { /* Check if company is not averecura / forum gerontologie to hide / show the Betriebszugehörigkeit  */
            company !== "digallo" && company !== "forum-gerontologie" ? (
            <a href="https://www.averecura.ch/" target='_blank' rel="noreferrer">
              <div className={styles.footerLogo}>
                <p><small>ein Betrieb der averecura holding</small></p>
                <Logo
                  company="digallo"
                  link="https://www.averecura.ch/"
                  type="color-black"
                  width="200px"
                  target="_blank"
                />
              </div>
            </a>
          ) : ""}
        </div>
          {legalfooter}
      </div>
    );} else {
      Footer = legalfooter
    }
  }

  return Footer;
}

Footer.propTypes = {
  backgroundImage: PropTypes.string,
};
